import ErrorMessage from "../components/common/ErrorMessage";
import {invalidQR} from "../libs/helpers";

const Home = ({message, location}) => {
    return <><ErrorMessage message={message || location?.state?.message || invalidQR()}/> </>
};

export default Home;
